import React from 'react'
import './Form.css'

import axios from 'axios'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import qs from 'qs' // from php

import { LeftSvg, MailSvg } from './SVGarr'
import ScrollToTopOnMount from './ScrollToTopOnMount'

class Form extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      user: '',
      tel: '',
      email: '',
      text: '',
      toggle: false,
      message: <div className="mailPreload">{MailSvg}</div>,
      messageOK: true
    }
    this.hendelSubmit = this.hendelSubmit.bind(this)
    this.hendelUserChange = this.hendelUserChange.bind(this)
    this.hendelTellChange = this.hendelTellChange.bind(this)
    this.hendelEmailChange = this.hendelEmailChange.bind(this)
    this.hendelTextChange = this.hendelTextChange.bind(this)
    this.toggleFalse = this.toggleFalse.bind(this)
  }

  hendelSubmit(event) {
    event.preventDefault()
    this.setState({ toggle: true })
    axios.post('/mail.php', 
      qs.stringify({
        'user': this.state.user, 
        'tel': this.state.tel, 
        'email': this.state.email,
        'text': this.state.text
      })  
    ).then((res) => {
      // if (res.data.msg === 'success')
      if (res.data) {
        this.setState({ message: this.props.t('mSuccess') })
        // if (res.data.msg === 'fail')
      } else if (!res.data) {
        this.setState({ message: this.props.t('mFail'), messageOK: false })
        }
    })
  }

  hendelUserChange(event) { this.setState({ user: event.target.value }) }
  hendelTellChange(event) { this.setState({ tel: event.target.value }) }
  hendelEmailChange(event) { this.setState({ email: event.target.value }) }
  hendelTextChange(event) { this.setState({ text: event.target.value }) }
  toggleFalse() { this.setState({ toggle: false }) }

  render() {
    const { t } = this.props
    let popapp
    if (this.state.toggle) { popapp =  <div className="wrapPopapp">
                              <div className={ `popapp ${this.state.messageOK ? 'success' : 'fail'}` }>
                                {this.state.message}
                                <Link to="#" onClick={this.toggleFalse}> OK </Link>
                              </div>
                            </div>
    }

    return (
      <ReactCSSTransitionGroup
      transitionName="homeTransition"
      transitionAppear={true}
      transitionAppearTimeout={500}
      transitionEnter={false}
      transitionLeave={false}>
        <div className="formWrap">
          <ScrollToTopOnMount />
          <form id="form" onSubmit={this.hendelSubmit}>
            {popapp}
            <input 
              type="text" 
              placeholder={t('formName')}
              value={this.state.user} 
              onChange={this.hendelUserChange}
              maxLength="15"
              required
            />
            <input 
              type="tel" 
              placeholder={t('formTel')}
              value={this.state.tell} 
              onChange={this.hendelTellChange}
              maxLength="15"
              required
            />
            <input
              type="email" 
              placeholder={t('formEmail')}
              value={this.state.email} 
              onChange={this.hendelEmailChange} 
              maxLength="30"
            />
            <textarea 
              placeholder={t('formText')}
              value={this.state.text} 
              onChange={this.hendelTextChange}
              maxLength="700"
            >
            </textarea>
            <div className="formDown">
              <Link to="/"> {LeftSvg} </Link>
              <button type="submit"> {t('formButton')} </button>
            </div>
          </form>
        </div>
      </ReactCSSTransitionGroup>
    )
  }
}

export default translate('translations')(Form)


// WEBPACK FOOTER //
// ./src/components/Form.jsx